import { ArrowUpRight } from "lucide-react";

export const Footer = () => {
    return (
        <footer
            data-testid="footer"
            className="border-t border-black/5 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                    <p className="font-heading text-2xl font-bold tracking-tight text-black">
                        Marlea
                    </p>
                    <a
                        data-testid="footer-email"
                        href="mailto:marlea.agency@gmail.com"
                        className="text-sm text-neutral-700 hover:text-black transition-colors inline-flex items-center gap-1 link-underline font-medium"
                    >
                        marlea.agency@gmail.com
                        <ArrowUpRight className="w-3.5 h-3.5" />
                    </a>
                </div>

                <div className="border-t border-black/5 mt-10 pt-6">
                    <p className="text-xs text-neutral-500">
                        © {new Date().getFullYear()} Marlea. All rights
                        reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};
